import Card from 'react-bootstrap/Card';
import "../styles/dashbaords.scss";

const SkillScrollCarousel = ({ skills }) => (
  <div className="skill-scroll-outer">
    <div className="skill-scroll-track">
      {[...skills, ...skills].map((skill, idx) => (
        <div key={idx} className="skill-scroll-item">
          <Card className="h-100 shadow-sm">
            <Card.Body>
              <Card.Title className="fs-6">{(idx % skills.length) + 1}. {skill.title}</Card.Title>
              {skill.description && (
                <Card.Text className="small text-muted">{skill.description}</Card.Text>
              )}
            </Card.Body>
          </Card>
        </div>
      ))}
    </div>
  </div>
);

export default SkillScrollCarousel;
